import {
    SimplePresentation,
    SimplePresentationRunnerController
} from "../../../core/winpresentation/SimplePresentationRunner";
import {gsap} from "gsap";
import {DasUBoot} from "../../DasUBoot";
import {DasUBootGameMode} from "../../server/DasUBootGameMode";
import {DasUBootRoundType} from "../../server/DasUBootData";
import {SymbolUtils} from "../../utils/SymbolUtils";
import {DasUBootSymbolStates} from "../../reels/DasUBootSymbol";
import {ModeTransition, TextSpriteTexture} from "../../view/ModeTransitionScreen";

/**
 * Created by jonas on 2021-02-19.
 */

export class FreeSpinIntro implements SimplePresentation {

    start(controller:SimplePresentationRunnerController):void {
        const youWonTranslation = DasUBoot.apiPlugin.translations.translate("YOU WON");
        const freespinsTranslation = DasUBoot.apiPlugin.translations.translate("FREESPINS");

        const tl:gsap.core.Timeline = gsap.timeline();
        tl.add(() => {
            DasUBoot.autoPlayPlugin.turnOffAutoplayOnBonus();
        });

        tl.add(() => {
            DasUBoot.transitionScreen.setText(`${youWonTranslation}`);
            DasUBoot.transitionScreen.setTextSprite(TextSpriteTexture.FREE_SPIN);
        });

        tl.add([
            DasUBoot.transitionScreen.show(ModeTransition.FREE_SPIN, true),
            ()=>DasUBoot.soundPlayer.playIntroSound(DasUBootRoundType.FREE_SPIN)
        ]);

        tl.add(SymbolUtils.getSymbolStateAnimations(DasUBoot.reelView.getAllVisibleSymbols(), DasUBootSymbolStates.NORMAL));
        tl.add(() => DasUBoot.transitionScreen.enableButton(() => this.endAnimation(controller)));

    }

    private endAnimation(controller:SimplePresentationRunnerController) {
        const tl:gsap.core.Timeline = gsap.timeline({onComplete:() => controller.finish()});
        tl.add(() => {
            DasUBoot.backgroundElements.setMode(DasUBootRoundType.FREE_SPIN, 1.0),
            DasUBoot.soundPlayer.stopIntroSound(DasUBootRoundType.FREE_SPIN)
        });
        tl.add(DasUBoot.transitionScreen.hide());
        tl.add(() => DasUBoot.keypadPlugin.setZeroBetSpinCounter(DasUBoot.model.data.freespinsLeft));
        tl.add([
            DasUBoot.reelView.reelFrame.xBombMultiplierDisplay.setMultiplier(DasUBoot.model.clientData.multipliers.stickyFSMultiplier | 0, true),
            DasUBoot.reelView.raisePeriscope(true)
        ]);
    }

    shouldRun():boolean {
        return DasUBoot.model.data.mode != DasUBootGameMode.FREESPIN && DasUBoot.model.data.nextMode == DasUBootGameMode.FREESPIN && DasUBoot.model.data.freespinTriggeredThisSpin;
    }
}